import React from 'react';

import { subscribe_path, upgrade_subscription_path } from '@routes';

import { ProButton, TextButton } from '../../Button/variants';

interface ProCTAProps {
  defaultProOfferCode: string;
}

const ProCTA = ({ defaultProOfferCode }: ProCTAProps) => {
  return (
    <div className="py-48 lg:py-64">
      <h2 className="m-auto my-0 mb-16 max-w-[660px] text-center font-suisse-works text-headline-xs text-primary-black sm:mb-24 sm:text-headline-md lg:max-w-full">
        Better decision-making starts with The Information Pro
      </h2>
      <ProButton as="link" href={subscribe_path({ plan: defaultProOfferCode })} className="m-auto">
        Subscribe today
      </ProButton>
      <p className="m-0 mt-16 flex items-center justify-center font-suisse-screen text-disclosure-sm text-primary-black sm:mt-24 sm:text-disclosure-lg">
        Already a The Information subscriber?
        <TextButton
          as="link"
          href={upgrade_subscription_path()}
          className="ml-2 !w-fit font-suisse-screen text-disclosure-sm font-medium sm:text-disclosure-lg"
        >
          Upgrade to Pro
        </TextButton>
      </p>
    </div>
  );
};

export default ProCTA;
